export const colors = {
  primary: '#003366',
  secondary: '#4A90E2',
  background: '#F8F9FA',
  surface: '#FFFFFF',
  cardBackground: '#FFFFFF',  // Added explicit white background for cards
  text: '#1A1A1A',
  textSecondary: '#666666',
  border: '#E1E1E1',
  success: '#28A745',
  error: '#DC3545',
  warning: '#FFC107',
  info: '#17A2B8',
  disabled: '#6C757D',
  ripple: 'rgba(0, 51, 102, 0.1)',
} as const;
